<template>
  <v-card flat>
    <h3 v-if="form.protocolCompleted" class="text-danger text-right">
      Добавена към протокол: {{ form.protocolName }}
    </h3>
    <b-row>
      <b-form-group
        class="col-md-4"
        id="item-bill-number-group"
        :label="$t('MENU.ITEM.ACTIVITIES.BILL_OF_LADING_NUMBER')"
        label-for="item-bill-number-input"
      >
        <div class="input-group">
          <FormInput
            id="bill-number-input"
            type="text"
            name="bill_number"
            :i18n="{
              label: 'MENU.ITEM.ACTIVITIES.BILL_OF_LADING_NUMBER',
              placeholder: $t('MENU.ITEM.ACTIVITIES.BILL_OF_LADING_NUMBER')
            }"
            :validateState="validateState('billNumber')"
            v-model="form.billNumber"
            @blur="handleBillNumberBlur"
          ></FormInput>
        </div>
      </b-form-group>

      <b-form-group
        class="col-md-4"
        id="item-assignors-group"
        v-bind:label="$t('MENU.ITEM.ASL.ASSIGNOR')"
        label-for="item-assignor-input"
      >
        <FormSelect
          id="item-assignors-input"
          type="select"
          clearable
          name="itemAssignors"
          :options="assignors"
          v-model="form.assignorId"
          @input="fetchAssignorLocations"
        ></FormSelect>
      </b-form-group>

      <b-form-group
        class="col-md-4"
        id="item-locations-group"
        v-bind:label="$t('MENU.ITEM.ASL.LOCATION')"
        label-for="item-locations-input"
      >
        <FormSelect
          id="item-locations-input"
          type="select"
          clearable
          name="itemLocations"
          :options="locations"
          v-model="form.locationId"
          @input="fetchServices"
        ></FormSelect>
      </b-form-group>

      <b-form-group
        class="col-md-4"
        id="item-vehicle-group"
        :label="$t('FORM_PLACEHOLDERS.MACHINE')"
        label-for="item-reg-plate-input"
      >
        <FormSelect
          id="item-vehicle-number-input"
          type="select"
          clearable
          name="itemMachine"
          :options="vehicles"
          v-model="form.machine"
          :validateState="validateState('machine')"
          @input="getVehicle($event)"
        ></FormSelect>
      </b-form-group>

      <b-form-group
        class="col-md-4"
        id="item-measures-group"
        :label="$t('MENU.ITEM.STAFF.STAFF')"
        label-for="item-measures-input"
      >
        <FormSelect
          :key="staffListKey"
          id="item-staff-input"
          type="select"
          clearable
          name="itemStaff"
          :options="localStaffList"
          v-model="form.staffId"
        ></FormSelect>
      </b-form-group>

      <b-form-group
        class="col-md-4"
        id="item-bill-date-group"
        :label="$t('MENU.ITEM.ACTIVITIES.BILL_OF_LADING_DATE')"
        label-for="item-bill-date-input"
      >
        <FormDatepicker
          id="bill-of-lading-date-input"
          type="date"
          name="bol_date"
          :i18n="{
            placeholder: 'FORM_LABELS.DATE'
          }"
          :validateState="validateState('bolDate')"
          v-model="form.bolDate"
          :max="today"
          @input="setServiceDates()"
        ></FormDatepicker>
      </b-form-group>
    </b-row>
    <b-row>
      <b-form-group
        class="col-md-12"
        id="item-bill-note-group"
        :label="$t('MENU.ITEM.ACTIVITIES.BILL_OF_LADING_NOTE')"
        label-for="item-bill-note-input"
      >
        <div class="input-group">
          <FormInput
            id="bill-note-input"
            type="text"
            name="bill_note"
            :i18n="{
              label: 'FORM_LABELS.NOTE',
              placeholder: $t('FORM_LABELS.NOTE')
            }"
            :validateState="{}"
            v-model="form.note"
          ></FormInput>
        </div>
      </b-form-group>
    </b-row>

    <b-row>
      <div class="col-md-4 d-flex align-center">
        <h3>Дейности ({{ form.work.length }})</h3>
      </div>
      <div class="col-md-8 text-right">
        <button
          v-if="form.locationId"
          class="btn btn-info mr-2"
          @click="openModal"
        >
          Услуги {{ selectedLocationName }}
        </button>
        <button class="btn btn-success" v-on:click="handleAddWork">
          <strong>+ Добави дейност</strong>
        </button>
      </div>
    </b-row>

    <b-row class="service-section" v-for="(item, i) in form.work" :key="i">
      <b-col :md="4">
        <b-form-group
          :label="$t('MENU.ITEM.ACTIVITIES.BILL_OF_LADING_WORKING_DATE')"
          label-for="item-working-date-input"
        >
          <FormDatepicker
            type="date"
            :i18n="{
              placeholder: 'FORM_LABELS.DATE'
            }"
            v-model="form.work[i].dateWorked"
            :max="today"
          ></FormDatepicker>
        </b-form-group>
      </b-col>
      <b-col :md="4">
        <b-form-group
          id="item-service-group"
          :label="$t('FORM_LABELS.SERVICE')"
          label-for="item-service-input"
        >
          <FormSelect
            clearable
            type="select"
            :options="services"
            v-model="form.work[i].serviceId"
            @input="handleServiceChange(i, $event)"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col :md="2">
        <b-form-group :label="$t('FORM_LABELS.QTY')" label-for="item-qty-input">
          <div class="input-group">
            <FormInput
              type="number"
              :i18n="{
                label: 'FORM_LABELS.QTY',
                placeholder: $t('FORM_LABELS.QTY')
              }"
              v-model="form.work[i].serviceQty"
              :validateState="{}"
              @input="totalQty"
            ></FormInput>
          </div>
        </b-form-group>
      </b-col>
      <b-col :md="2">
        <b-form-group
          id="item-measure-group"
          v-bind:label="$t('MENU.ITEM.MEASURES.MEASURE')"
          label-for="item-measure-input"
        >
          <FormSelect
            type="select"
            disabled
            clearable
            :options="measures"
            v-model="form.work[i].measureId"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="item-work-note-group"
          v-bind:label="$t('FORM_LABELS.NOTE')"
          label-for="item-work-note-input"
        >
          <FormInput
            type="text"
            :i18n="{
              label: 'FORM_LABELS.NOTE',
              placeholder: $t('FORM_LABELS.NOTE')
            }"
            v-model="form.work[i].note"
            :validateState="{}"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col v-if="form.work[i].isUnloading" :md="5">
        <b-form-group
          id="item-unloading-group"
          v-bind:label="$t('FORM_LABELS.UNLOADING')"
          label-for="item-unloading-input"
        >
          <FormSelect
            type="select"
            clearable
            :options="subcontractorLocations"
            v-model="form.work[i].subcontractorsLocationId"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col v-if="i > 0" :md="1">
        <b-form-group class="text-right">
          <button
            class="btn btn-danger mt-6 pr-2 pl-3"
            v-on:click="form.work.splice(i, 1)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </b-form-group>
      </b-col>
    </b-row>
    <ServicesModal
      ref="ServicesModal"
      :location-id="form.locationId"
      @updated="handleServicesUpdated"
    ></ServicesModal>
  </v-card>
</template>

<script>
import { FETCH_MACHINES } from "@/modules/machines/store/machine.module";
import {
  FETCH_RENTED_MACHINES,
  FETCH_RENTED_MACHINE
} from "@/modules/rented-machines/store/rentedmachine.module";
import { FETCH_LOCATION_SERVICES } from "@/modules/assignorslocation/store/location-service.module";
import { FETCH_ALL_STAFF } from "@/modules/staff/store/staff.module";
import { FETCH_ASSIGNOR_LOCATIONS } from "@/modules/assignorslocation/store/location.module";
import { FETCH_MEASURES } from "@/modules/measures/store/measures.module";
import { FETCH_ASSIGNORS } from "@/modules/assignors/store/assignors.module";
import { FETCH_SERVICES } from "@/modules/services/store/service.module";
import { FETCH_SUBCONTRACTOR_LOCATIONS } from "@/modules/subcontractorslocation/store/location.module";

import FormInput from "@/view/content/forms/components/FormInput.vue";
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";
import FormSelect from "../../../view/content/forms/components/FormSelect";
import ServicesModal from "./ServicesModal";

import { validationMixin } from "vuelidate";
import { formBuilderMixin } from "@/core/mixins/formBuilderMixin.js";
import { FETCH_BILL_OF_LADINGS } from "../store/bill-of-lading.module";

export default {
  name: "BillOfLadingForm",
  mixins: [validationMixin, formBuilderMixin],
  components: {
    FormSelect,
    FormInput,
    FormDatepicker,
    ServicesModal
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    staffList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      today: new Date().toISOString().slice(0, 10),
      errors: {},
      locations: [],
      measures: [],
      assignors: [],
      vehicles: [],
      localStaffList: [],
      services: [],
      subcontractorLocations: [],
      staffListKey: 0
    };
  },
  computed: {
    selectedLocationName() {
      const loc = this.locations.find(s => s.id === this.form.locationId);
      return loc ? loc.name : null;
    }
  },
  validations() {
    return {
      form: {
        billNumber: this.setItemValidations({
          required: true
        }),
        bolDate: this.setItemValidations({
          required: true
        }),
        machine: this.setItemValidations({
          required: true
        })
      }
    };
  },
  mounted() {
    this.fetchServices();
    this.fetchAssignors();
    this.fetchMeasures();
    this.fetchMachines();
    this.fetchSubcontractorLocations();
  },
  watch: {
    staffList: {
      handler(newStaffList) {
        if (
          newStaffList &&
          Array.isArray(newStaffList) &&
          newStaffList.length > 0
        ) {
          this.localStaffList = newStaffList.map(staff => ({
            id: staff.id,
            name: staff.name
          }));
          this.staffListKey += 1;
        } else {
          this.fetchAllStaff();
        }
      },
      immediate: true
    }
  },
  methods: {
    fetchAllStaff() {
      this.$store.dispatch(FETCH_ALL_STAFF, "?active=1").then(data => {
        this.localStaffList = (data.data.items || []).map(s => ({
          id: s.id,
          name: s.name
        }));
        this.staffListKey += 1;
      });
    },
    fetchAssignors() {
      this.$store
        .dispatch(
          FETCH_ASSIGNORS,
          this.$url.transformParams({
            onlySelectValues: true,
            selectValueKey: "company_name"
          })
        )
        .then(data => {
          this.assignors = data.data.items;
          if (this.form.assignorId) {
            this.fetchAssignorLocations(this.form.assignorId);
          }
        });
    },
    fetchMeasures() {
      this.$store.dispatch(FETCH_MEASURES).then(data => {
        this.measures = data.data.items;
      });
    },
    fetchMachines() {
      this.$store.dispatch(FETCH_MACHINES, "?active=1").then(data => {
        let vehicles = [];
        (data.data.items || []).forEach(item => {
          vehicles.push({
            id: {
              machinableId: item.id,
              machinableType: item.expenseType,
              lastUsedStaffId: item.lastUsedStaffId
            },
            name: item.name + " - Собствена"
          });
        });
        this.vehicles = vehicles;

        this.$store.dispatch(FETCH_RENTED_MACHINES).then(data => {
          (data.data.items || []).forEach(item => {
            this.vehicles.push({
              id: {
                machinableId: item.id,
                machinableType: item.expenseType,
                lastUsedStaffId: ""
              },
              name: item.name + " - " + item.subcontractorName
            });
          });
          if (this.form.machine) {
            this.fetchStaff(this.form.machine);
          }
        });
      });
    },
    fetchSubcontractorLocations() {
      this.$store
        .dispatch(
          FETCH_SUBCONTRACTOR_LOCATIONS,
          this.$url.transformParams({
            onlySelectValues: true,
            selectValueKey: "location_name",
            onlyMaterial: true
          })
        )
        .then(data => {
          this.subcontractorLocations = data.data.items;
        });
    },
    fetchServices(id = null) {
      const dispatchAction = id ? FETCH_LOCATION_SERVICES : FETCH_SERVICES;
      const param = id || undefined;

      this.$store.dispatch(dispatchAction, param).then(data => {
        const items = id ? data.data : data.data.items;
        this.services = items.map(s => ({
          id: s.serviceId,
          name: s.name,
          measureId: s.measureId,
          measureName: s.measureName,
          isUnloading: s.isUnloading
        }));

        if (id) {
          this.checkExistingServices();
        }
      });
    },
    fetchAssignorLocations(id) {
      this.locations = [];
      this.$store
        .dispatch(
          FETCH_ASSIGNOR_LOCATIONS,
          this.$url.transformParams({
            assignorId: id
          })
        )
        .then(data => {
          this.locations = data.data.items || [];
          this.form.locationId = this.locations.find(
            l => l.id === this.form.locationId
          )
            ? this.form.locationId
            : null;

          if (this.locations.length === 1) {
            this.form.locationId = this.locations[0].id;
          }

          this.fetchServices(this.form.locationId);
        });
    },
    openModal() {
      this.$refs.ServicesModal.show();
    },
    getVehicle(event) {
      this.fetchStaff(event);
    },
    setServiceDates() {
      this.form.work.forEach(fs => {
        fs.dateWorked = this.form.bolDate;
      });
    },
    handleAddWork() {
      const lastWork = this.form.work[this.form.work.length - 1];
      this.form.work.push({
        ...lastWork,
        id: null
      });
    },
    fetchStaff(event) {
      if (!this.staffList || this.staffList.length === 0) {
        this.localStaffList = [];
      }

      if (event && event.machinableType == "OwnMachineExpense") {
        this.$store.dispatch(FETCH_ALL_STAFF, "?active=1").then(data => {
          if (!this.staffList || this.staffList.length === 0) {
            this.localStaffList = (data.data.items || []).map(s => ({
              id: s.id,
              name: s.name
            }));
            this.staffListKey += 1;
          }

          this.form.staffId = event.lastUsedStaffId || null;
        });
      } else if (event && event.machinableType == "RentedMachineExpense") {
        this.$store
          .dispatch(FETCH_RENTED_MACHINE, event.machinableId)
          .then(data => {
            if (!this.staffList || this.staffList.length === 0) {
              this.localStaffList = [{ id: "", name: data.data.staffName }];
              this.staffListKey += 1;
            }
            this.form.staffId = "";
          });
      }
    },
    checkExistingServices() {
      this.form.work.forEach((work, index) => {
        if (work.serviceId) {
          const service = this.services.find(s => s.id === work.serviceId);
          if (service) {
            this.form.work[index].measureId = service.measureId;
            this.form.work[index].isUnloading = service.isUnloading || false;
          }
        }
      });
    },
    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    handleServiceChange(index, serviceId) {
      if (serviceId) {
        const service = this.services.find(s => s.id === serviceId);
        if (service) {
          this.form.work[index].measureId = service.measureId;
          this.form.work[index].isUnloading = service.isUnloading || false;
          if (!this.form.work[index].isUnloading) {
            this.form.work[index].subcontractorsLocationId = null;
          }
        }
      }
    },
    handleServicesUpdated() {
      this.fetchServices(this.form.locationId);
    },
    totalQty() {
      return this.form.work.reduce((total, work) => {
        return total + (parseFloat(work.serviceQty) || 0);
      }, 0);
    },
    handleBillNumberBlur() {
      this.$store
        .dispatch(
          FETCH_BILL_OF_LADINGS,
          this.$url.transformParams({
            billNumber: this.form.billNumber,
            itemsPerPage: 1
          })
        )
        .then(data => {
          if (data.data.items && data.data.items.length > 0) {
            if (data.data.items[0].id != this.form.id) {
              this.$notify({
                group: "notify",
                type: "warning",
                title: `<i class='flaticon-close'></i> ${this.$t(
                  "ALERTS.WARNING"
                )}`,
                text: this.$t("ALERTS.BILL_NUMBER_EXIST")
              });
            }
          }
        });
    }
  }
};
</script>

<style scoped>
.service-section {
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #dee2e6;
}
</style>
